import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppRootState} from '../appStore';

export interface ColumnOrderState {
    columnOrder: string[];
}

let initialState: ColumnOrderState = {
    columnOrder: [],
};

export const columnOrderSlice = createSlice({
    name: 'ColumnOrder',
    initialState,
    reducers: {
        setColumnOrders: (state, action: PayloadAction<string[]>) => {
            state.columnOrder = action.payload;
        },
        addColumnOrder: (state, action: PayloadAction<string>) => {
            state.columnOrder = [...state.columnOrder, action.payload];
        },
    },
});

export const {setColumnOrders, addColumnOrder} = columnOrderSlice.actions;

export const ColumnOrderSliceReducer = columnOrderSlice.reducer;
export const ColumnOrderSelector = (rootState: AppRootState): ColumnOrderState => rootState.columnOrder;
